import System from "../../helper/system";
import Constants from "../../helper/Constants";

export default function exportProductListingData() {
  const {siteUser} = Constants

  const export_keys = {
    'ERPMFRPartNumber': 'Part Number',
    'ManufacturerName': 'Manufacturer',
    'Availability': 'Stock (Availability)',
    'LeadtimeDays': 'Lead Time',
    'Quantity': 'Quantity',
    'Min': 'Min',
    'Mult': 'Mult',
    'Currency': 'Currency',
    'DatasheetUrl': 'Datasheet',
    'Description': 'Product Description'
  }
  export_keys.CustomerPartNumbers = System.avUserInfoData.currentUser === siteUser.CORE ? 'Customer Part Number' : undefined;
  return export_keys;
};

export function functionDataOrder() {
  const {siteUser} = Constants

  return ["Part Number"]
    .concat((System.avUserInfoData.currentUser === siteUser.CORE ? ["Customer Part Number"] : []))
    .concat(
      ["Manufacturer",
        "Stock (Availability)",
        "Lead Time",
        "Quantity",
        "Min",
        "Mult",
        "Currency",
        "Datasheet",
        "Description"
      ]);
}